module.exports = __webpack_public_path__ + "img/icon-usp-greeting-card.1688c9ee.svg";